import React from 'react';
import { Link } from "react-router-dom";

export const OurBrands = () => {
	return (
		<div className="xl:my-16 my-8">
			<div className="border_style">
				<h2 className="flex mb-8 text-3xl">OUR BRANDS</h2>
				<Link to="#"><img src="images/offer-banner.jpg" alt="Our Brands" /></Link>
			</div>
		</div>
	)
}
